import React from 'react';
import { IconRadar2, IconPlugConnected, IconCameraSelfie, IconDoor, IconUrgent, IconClipboardList } from '@tabler/icons-react';
const features = [{
  icon: <IconRadar2 size={28} stroke={1.5} data-id="element-88" />,
  title: 'Matching di prossimità',
  description: "L'algoritmo incrocia check-in e check-out vicini per raggruppare gli interventi nella stessa zona. Meno spostamenti, più efficienza.",
  color: '#002CA5'
}, {
  icon: <IconPlugConnected size={28} stroke={1.5} data-id="element-89" />,
  title: 'Integrazione con i tuoi strumenti',
  description: 'Airbnb, Booking, Expedia, Smoobu, Lodgify — CleanAI si collega ai principali channel manager e piattaforme in pochi secondi.',
  color: '#002CA5'
}, {
  icon: <IconCameraSelfie size={28} stroke={1.5} data-id="element-90" />,
  title: 'Verifica fotografica con scoring',
  description: 'Foto prima e dopo ogni intervento, analizzate automaticamente. Ogni pulizia riceve un punteggio di qualità verificabile.',
  color: '#FF4081'
}, {
  icon: <IconDoor size={28} stroke={1.5} data-id="element-91" />,
  title: 'Apertura automatica della porta',
  description: "Cleaner e manutentori accedono all'appartamento in autonomia grazie all'integrazione con le serrature smart. Nessuna chiave da consegnare.",
  color: '#FF4081'
}, {
  icon: <IconUrgent size={28} stroke={1.5} data-id="element-92" />,
  title: 'Manutenzione urgente rapida',
  description: 'Qualcosa si è rotto a poche ore dal check-in? CleanAI trova chi è già operativo in zona e lo attiva in tempi record.',
  color: '#002CA5'
}, {
  icon: <IconClipboardList size={28} stroke={1.5} data-id="element-93" />,
  title: 'Segnalazioni in-house',
  description: "I cleaner possono segnalare guasti e anomalie direttamente dall'app durante l'intervento. Tu ricevi tutto in tempo reale.",
  color: '#FF4081'
}];
export function FeaturesGridSection() {
  return <section className="py-20 md:py-24 px-5 w-full" style={{
    background: '#F5F7FA'
  }} data-id="element-94">
      <div className="max-w-6xl mx-auto" data-id="element-95">
        {/* Header */}
        <div className="text-center" data-id="element-96">
          <div className="flex justify-center mb-4" data-id="element-97">
            <span className="inline-block border rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest" style={{
            borderColor: '#FF4081',
            color: '#FF4081'
          }} data-id="element-98">
              FUNZIONALITÀ
            </span>
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl text-navy text-center" data-id="element-99">
            Tutto quello che serve,{' '}
            <span style={{
            color: '#FF4081'
          }} data-id="element-100">
              in un'unica piattaforma.
            </span>
          </h2>

          <div className="flex justify-center mt-4" data-id="element-101">
            <div style={{
            width: '40px',
            height: '3px',
            background: '#FF4081',
            borderRadius: '2px'
          }} data-id="element-102" />
          </div>

          <p className="font-body text-body-gray text-base md:text-lg mt-4 max-w-2xl mx-auto text-center leading-relaxed" data-id="element-103">
            CleanAI non è solo pulizie. È un sistema completo per gestire ogni
            aspetto operativo dei tuoi appartamenti.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-14" data-id="element-104">
          {features.map((feature, idx) => <div key={idx} className="bg-white p-7 border-2 rounded-none" style={{
          borderColor: feature.color
        }} data-id="element-105">
              {/* Icon */}
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-5" style={{
            background: `${feature.color}12`,
            color: feature.color
          }} data-id="element-106">
                {feature.icon}
              </div>

              {/* Title */}
              <h3 className="font-heading font-semibold text-lg md:text-xl text-navy mb-3" data-id="element-107">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="font-body text-body-gray text-sm md:text-base leading-relaxed" data-id="element-108">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}